import styled from "styled-components";
import { typography } from "src/theme";
import { colors } from "src/theme/colors";
import device from "src/constants/media";

interface WrapperType {
  filled: boolean;
}
export const InputWrapper = styled.div<WrapperType>`
  padding: 8px;
  border: ${({ filled }) => (filled ? `1px solid ${colors.greyLight}` : "1px solid red")};
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  align-items: center;
`;
export const Textarea = styled.textarea`
  width: 100%;
  height: 76px;
  border-radius: 8px;
  resize: none;
  border: none;
  box-sizing: border-box;
  backdrop-filter: blur(27.1828px);
  outline: none;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey};
`;
